(function( $ ) {

	$( document ).ready( () => {

		$( document ).on( 'click', '.nav-bar .search .icon-search', function() {
			console.log( 'werk')
			$( this ).parent().find('form').submit()
		} )

	} )

})( jQuery );


// WEBPACK FOOTER //
// ./assets/js/layout/nav.js